/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-02-22",
    versionChannel: "nightly",
    buildDate: "2024-02-22T00:05:47.947Z",
    commitHash: "6a548225f7b81ce4cb61be934a21514c82e055ea",
};
